import * as SVG from 'svg.js';

import { DragInfo, HandleBase, Placement, RoughBox } from './handle.base';

export class MoveHandle extends HandleBase
{
  constructor(element: SVG.Element, handleGroup: SVG.G) {
    super(
        element,
        handleGroup.rect()
          .style({
            'fill': 'transparent',
            'cursor': 'move',
            'pointer-events': 'auto'
          }));
  }

  protected drag(info: DragInfo): Placement {
    return {
      x: info.reference.x + info.delta.x,
      y: info.reference.y + info.delta.y,
    };
  }

  protected updateControl(bounds: RoughBox): void {
    this.control.move(bounds.x, bounds.y).size(bounds.width, bounds.height);
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/transform-handle/handle.move.ts